module.exports = __webpack_public_path__ + "static/media/BoxPlotQ2_3.9c78d60e.svg";